export default __webpack_public_path__ + "static/media/WaterCoverageFrequency.cae66aec.png";